<style lang="less" scoped>
   .vuetify-page {
     display: flex;
     align-items: center;
    .select-contain {
        width: 100px;
        /deep/ .v-text-field__details {
            display: none;
        }
     /deep/.v-input__slot {
         margin-bottom: 0px;
     }
    }
    .input-contain {
        display: flex;
        align-items: center;
        margin-left: 20px;
        /deep/.v-text-field__details {
          display: none;
        }
    }
    .v-pagination {
      /deep/ .v-pagination__item {
        margin-top: 0px;
        margin-bottom: 0px;
      }
    }
   }
</style>
<template>
  <div class="vuetify-page">
    <div>
      共{{ total }}条
    </div>
    <v-pagination
      class="v-pagination"
      :value="current"
      style="width:fit-content"
      :length="len"
      total-visible="8"
      @input="changePageFromP"
    />
    <div 
      v-if="sizeArr&&sizeArr.length"
      class="select-contain"
    >
      <v-select
        :value="pageSize"
        :items="handleSizeArr"
        :height="24"
        
        dense
        @change="changePageSize"
      />
    </div>
    <div class="input-contain">
      <span> 跳至</span><span style="width:50px;margin-left:7px"><v-text-field 
        ref="input"
        :height="20"
        :value="current"
        @keydown="changePageFromK"
      /></span><span style="margin-left:7px">页</span>
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      total:{
        type: Number,
        default: () => 0
      },
      pageSize: {
        type: Number,
        default: () => 0
      },
      current: {
        type: Number,
        default: () => 0
      },
      sizeArr: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {
        
      }
    },
    computed: {
      len() {
        if (!this.pageSize) {return 0}
        return Math.ceil((this.total || 0) / this.pageSize)
      },
      handleSizeArr() {
        if (!this.sizeArr || (this.sizeArr && this.sizeArr.length === 0)) {
          return []
        }
        return this.sizeArr.map(item => ({
          text: `${item} 条/页`,
          value: item
        }))
      }
    },
    methods: {
      changePageFromP(page) {
        this.changePage(page)
      },
      changePageSize(page) {
        this.$emit('changePageSize', page)
      },
      changePage(page) {
        if (page === this.current) {
          return 
        }
        this.$emit('pageChange', page)
      },
      changePageFromK(e) {
        if (e.key === 'Enter' || e.code === 'Enter') {
          const isillegality = !(/(^[0-9]\d*$)/.test(this.$refs.input.internalValue)) || // 是否是非负整数
            this.$refs.input.internalValue < 1 || // 必须是大于等于1
            this.$refs.input.internalValue > this.len || // 并不能超过最大页数
            this.$refs.input.internalValue === this.current // 输入页码等于当前页码
          if (isillegality) {
            this.$refs.input.internalValue = this.current
            return
          }
          this.$emit('pageChange', this.$refs.input.internalValue)
        }
      }
    }
  }
</script>
